import { createSelector } from 'reselect';
import type { RootState } from 'typesafe-actions';

import type { ChatState } from './reducer';
export const getChat = (state: RootState) => state.chat;

export const getItem = createSelector(getChat, (state: ChatState) => state.item);
